import { render, staticRenderFns } from "./RepresentativeForms.vue?vue&type=template&id=f6f968c0&"
import script from "./RepresentativeForms.vue?vue&type=script&lang=js&"
export * from "./RepresentativeForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports